module.exports = __webpack_public_path__ + "img/6.fae3502d.png";